import React from 'react';
import { Card, Space, Tag, Alert } from 'antd';

const ERROR_TYPE_CONFIG = {
  syntax: { color: 'error', icon: '🔴', label: 'Синтаксична помилка' },
  macro: { color: 'warning', icon: '🟡', label: 'Помилка макросу' },
  'macro-comment': { color: 'warning', icon: '🟠', label: 'Помилка коментаря макросу' },
  security: { color: 'error', icon: '🔒', label: 'Помилка безпеки' },
} as const;

interface ValidationError {
  message: string;
  line?: number;
  column?: number;
  type: 'syntax' | 'macro' | 'macro-comment' | 'security';
}

interface ValidationErrorsCardProps {
  detailedErrors?: ValidationError[];
  errors?: string[];
}

export const ValidationErrorsCard: React.FC<ValidationErrorsCardProps> = ({
  detailedErrors,
  errors,
}) => {
  const errorCount = detailedErrors?.length || errors?.length || 0;

  if (errorCount === 0) {
    return null;
  }

  return (
    <Card
      title={
        <Space>
          <span>❌ Помилки в коді</span>
          <Tag color="red">{errorCount}</Tag>
        </Space>
      }
      type="inner"
      style={{ borderColor: '#ff4d4f' }}
    >
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        {detailedErrors && detailedErrors.length > 0 ? (
          detailedErrors.map((error, index) => {
            const config = ERROR_TYPE_CONFIG[error.type] || ERROR_TYPE_CONFIG.syntax;

            return (
              <Alert
                key={index}
                message={
                  <Space>
                    <span>{config.icon} {config.label}</span>
                    {error.line && (
                      <Tag color={config.color === 'error' ? 'red' : 'orange'}>
                        Рядок {error.line}
                        {error.column && `:${error.column}`}
                      </Tag>
                    )}
                  </Space>
                }
                description={error.message}
                type={config.color === 'error' ? 'error' : 'warning'}
                showIcon
                style={{ marginBottom: index < detailedErrors.length - 1 ? 8 : 0 }}
              />
            );
          })
        ) : (
          errors?.map((error, index) => (
            <Alert
              key={index}
              message={error}
              type="error"
              showIcon
              style={{ marginBottom: index < (errors?.length || 0) - 1 ? 8 : 0 }}
            />
          ))
        )}
      </Space>
    </Card>
  );
};

